import PropTypes from 'prop-types'
import { Component } from 'react'
import 'rodal/lib/rodal.css'

import template from './template.rt'
import './styles.css'

export class VideoModal extends Component {
  constructor(props) {
    super(props)
    this.getPlaylist = this.getPlaylist.bind(this)
  }

  getPlaylist() {
    const sources = []
    const { subtitles, vtt, urlHi, urlLow, url } = this.props

    if (urlHi) sources.push({ file: urlHi, label: 'HD' })
    if (urlLow) sources.push({ file: urlLow, label: 'SD' })
    if (url) sources.push({ file: url })

    const subs = subtitles
      ? subtitles.map((s, index) => ({
          file: s.file,
          label: s.label,
          kind: 'captions',
          default: index === 0 // first as default
        }))
      : []
    return [
      {
        sources,
        tracks: [
          {
            file: vtt,
            kind: 'thumbnails'
          },
          ...subs
        ]
      }
    ]
  }

  render() {
    return template.call(this)
  }
}

VideoModal.propTypes = {
  visible: PropTypes.bool,
  close: PropTypes.func.isRequired,
  autoPlay: PropTypes.bool,
  isYoutube: PropTypes.bool,
  isPlaying: PropTypes.bool,
  // default url with any quality
  url: PropTypes.string,
  // specific url with HD quality
  urlHi: PropTypes.string,
  // specific url with SD quality
  urlLow: PropTypes.string,
  subtitles: PropTypes.string,
  vtt: PropTypes.string
}
VideoModal.defaultProps = {
  autoPlay: true,
  isYoutube: false,
  isPlaying: false,
  subtitles: '',
  vtt: '',
  visible: false,
  url: '',
  urlHi: '',
  urlLow: ''
}

export default VideoModal
